import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const BrandRequestsLayout = lazy(() =>
  import(
    "@/features/brands/edit/components/requests/BrandRequestsLayout"
  ).then((m) => ({ default: m.BrandRequestsLayout })),
);

export const Route = createFileRoute(
  "/_auth/_app-shell/brands/$brandId/requests",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { brandId } = Route.useParams();

  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center py-16">
          Loading...
        </div>
      }
    >
      <BrandRequestsLayout brandId={Number(brandId)} />
    </Suspense>
  );
}
